/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_ServiceInputs */

const en_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service`)
};

const es_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicio`)
};

const fr_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service`)
};

const de_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstleistung`)
};

const ja_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービス`)
};

const zh_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务`)
};

const ar_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خدمة`)
};

const id_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layanan`)
};

const it_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servizio`)
};

const ru_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Услуга`)
};

const pt_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviço`)
};

const ko_badge_service = /** @type {(inputs: Badge_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서비스`)
};

/**
* | output |
* | --- |
* | "Service" |
*
* @param {Badge_ServiceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_service = /** @type {((inputs?: Badge_ServiceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_ServiceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_service(inputs)
	if (locale === "es") return es_badge_service(inputs)
	if (locale === "fr") return fr_badge_service(inputs)
	if (locale === "de") return de_badge_service(inputs)
	if (locale === "ja") return ja_badge_service(inputs)
	if (locale === "zh") return zh_badge_service(inputs)
	if (locale === "ar") return ar_badge_service(inputs)
	if (locale === "id") return id_badge_service(inputs)
	if (locale === "it") return it_badge_service(inputs)
	if (locale === "ru") return ru_badge_service(inputs)
	if (locale === "pt") return pt_badge_service(inputs)
	return ko_badge_service(inputs)
});